import { useEffect, useState } from "react";
import { getOfferedBank, uploadTransferReceipt } from "./Api";
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils";
import { notifyError, notifySuccess } from "../../utils/Notification"
import UploadFileDialog from "./UploadFileDialog";
import { useDispatch, useSelector } from "react-redux";
import { setIsHomeProcess } from "../../app/GlobalSlice";
import { isPhone } from "../../utils/PlatformHelper";

const PaymentTransfer = ({
  onSuccessUploadPaymentReceipt
}) => {

  const dispatch = useDispatch()

  const { screenSize } = useSelector(state => state.global)

  const [banks, setBanks] = useState([])

  const [isLoad, setIsLoad] = useState(false)

  const [uploadPhotoDialog, setUploadPhotoDialog] = useState({
    isOpen: false
  })

  useEffect(() => {
    setIsLoad(true)

    getOfferedBank()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setBanks(payload)
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => { setIsLoad(false) })
  }, [])

  function onUploadFile(file) {
    dispatch(setIsHomeProcess(true))

    uploadTransferReceipt(file)
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: _ => {
            notifySuccess("berhasil unggah bukti pembayaran")
            setUploadPhotoDialog({ ...uploadPhotoDialog, isOpen: false })
            onSuccessUploadPaymentReceipt()
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => {
        dispatch(setIsHomeProcess(false))
      })
  }

  return (
    <div>
      {uploadPhotoDialog.isOpen && (
          <UploadFileDialog 
            onClose={() => setUploadPhotoDialog({
              isOpen: false
            })}
            onFileSelected={onUploadFile}
          />
      )}
      <div
        className="w-full bg-gray-300 p-1.5 shadow-lg rounded-lg text-center relative p-2 space-y-2"
        style={{
          fontFamily: 'Nunito'
        }}
      >
        <div className="uppercase font-bold">
          Pembayaran Manual Transfer
        </div>
        <div
          className="bg-blue-100 p-2 px-5 rounded-lg"
          style={{
            fontSize: '14px'
          }}
        >
          <ol className="text-left">
            <li className="p-0">
              Verifikasi dilakukan hanya pada jam kerja
            </li>
            <li className="p-0">
              Anda perlu melampirkan bukti transfer via Whatsapp atau Sistem
            </li>
          </ol>
        </div>
      </div>
      <div
        className="space-y-5 p-5 border border-gray-300 rounded-lg shadow-lg"
        style={{
          marginTop: '-15px'
        }}
      >
        <div
          className="space-y-5"
        >
          {banks.map(b => (
            <div
              className={
                "p-2 border rounded-md flex items-center space-x-5 " +
                (isPhone(screenSize.width) ? '' : ' h-[70px] ')
              }
            >
              <div>
                <img src={b.imgBank} width="100px" height={"50px"}/>
              </div>
              <div
                style={{
                  fontSize: '14px'
                }}
              >
                <div>Bank   : {b.namaBank}</div>
                <div>No. Rek   : {b.norek}</div>
                <div>Atas Nama : {b.atasNama}</div>
              </div>
            </div>
          ))}
        </div>
        <div
          className="bg-blue-100 p-2 px-5 rounded-lg"
          style={{
            fontSize: '14px'
          }}
        >
          Silahkan lakukan pembayaran uang pendaftaran ke salah satu rekening bank di atas.
        </div>
        <div
          className="bg-blue-100 p-3 px-5 rounded-lg space-y-3"
          style={{
            fontSize: '14px'
          }}
        >
          <div>
          Sudah transfer? silahkan unggah bukti transfer via Whatsapp kami atau klik tombol unggah bukti transfer di bawah.
          </div>
          <div
            className="flex justify-center"
          >
            <button
              className="bg-blue-700 hover:bg-blue-500 text-white p-1 px-5 rounded-lg"
              onClick={() => setUploadPhotoDialog({ ...uploadPhotoDialog, isOpen: true }) }
            >
              Unggah Bukti Transfer
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentTransfer;